import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=25f40ef0&scoped=true"
import script from "./Transfers.vue?vue&type=script&lang=ts"
export * from "./Transfers.vue?vue&type=script&lang=ts"
import style0 from "./Transfers.scss?vue&type=style&index=0&id=25f40ef0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f40ef0",
  null
  
)

export default component.exports